import React from 'react';
import { Callout, Typography } from 'seagull';
import { pluralizeUnitName } from "../../../../utils/unit-name.utils";
import styles from "./BillServiceModal.module.scss";
import { serviceModel } from "../../../../models";
export default function CumulativeWarningCallout(props) {
  const {
    service,
    isWarning,
    billedQuantity,
    scheduledQuantity
  } = props;
  function getQuantityText(q) {
    return "".concat(q, " ").concat(pluralizeUnitName(q, serviceModel.unitName(service)));
  }
  return /*#__PURE__*/React.createElement(Callout, {
    className: styles.cumulativeWarning,
    intent: isWarning ? 'warning' : 'info',
    "data-testid": "bill-service-cumulative-warning"
  }, serviceModel.isVariablePrice(service.cost) ? /*#__PURE__*/React.createElement(React.Fragment, null, billedQuantity.gt(0) && /*#__PURE__*/React.createElement(Typography, {
    "data-testid": "bill-service-cumulative-billed-quantity",
    "data-quantity": billedQuantity
  }, "This service was billed for ", getQuantityText(billedQuantity), " this period."), scheduledQuantity.gt(0) && /*#__PURE__*/React.createElement(Typography, {
    "data-testid": "bill-service-cumulative-scheduled-quantity",
    "data-quantity": scheduledQuantity
  }, "This service is scheduled to be billed for ", getQuantityText(scheduledQuantity), " this period."), /*#__PURE__*/React.createElement(Typography, null, "Client approval is required if the preapproved quantity is exceeded.")) : /*#__PURE__*/React.createElement(React.Fragment, null, billedQuantity.gt(0) && /*#__PURE__*/React.createElement(Typography, {
    "data-testid": "bill-service-cumulative-billed-fixed"
  }, "This service has already been billed for the period."), scheduledQuantity.gt(0) && /*#__PURE__*/React.createElement(Typography, {
    "data-testid": "bill-service-cumulative-scheduled-fixed"
  }, "This service is scheduled to be billed for the period."), /*#__PURE__*/React.createElement(Typography, null, "An additional bill will require client's approval.")));
}